/* eslint-disable */
import { WebApi } from '../../services/WebApi';

const state = () => ({
    oneOffHourSearches: [],
    oneOffHourSearchesCleared: 0
})

const getters = {
    findOneOffHourSearch: (state) => (key) => {
        return state.oneOffHourSearches.find(ac => ac.key === key);
    }
}

const mutations = {
    addOneOffHourSearch(state, oneOffHourCache) {
        const existing = state.oneOffHourSearches.find(ac => ac.key === oneOffHourCache.key);
        if (existing) {
            oneOffHourCache.value.oneOffHours = existing.value.oneOffHours.concat(oneOffHourCache.value.oneOffHours);
        }
        const local = state.oneOffHourSearches.filter(ac => ac.key !== oneOffHourCache.key);
        local.push(oneOffHourCache);
        state.oneOffHourSearches = local;
    },
    setRetry(state, key) {
        const existing = state.oneOffHourSearches.find(ac => ac.key === key);
        if (existing) {
            existing.retry = true;
            existing.loading = false;
        }
    },
    clearOneOffHourSearches(state) {
        state.oneOffHourSearches = [];
        state.oneOffHourSearchesCleared++;
    }
}

const actions = {
    searchOneOffHoursBySiteId({ commit }, { key, siteId, payload }) {
        return new Promise((resolve, reject) => {
            commit('addOneOffHourSearch', {
                key: key,
                value: { oneOffHours: [], more: false },
                loading: true,
                attempted: true
            });
            WebApi.post('Portal/'+ siteId + '/OneOffHour/Search', payload)
                .then(response => {
                    commit('addOneOffHourSearch', {
                        key: key,
                        value: {
                            oneOffHours: response.data
                        },
                        loading: false
                    });
                    resolve(response);
                })
                .catch(error => {
                    commit('setRetry', key);
                    reject(error);
                });
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
